import React from 'react'

import type {
  FilterComponentProps,
  FilterOperatorOption,
} from 'types/filter-page'

import { TextField } from 'components/ds'

import { useKeyPress } from 'hooks/use-key-press'

import { FilterOperatorSelector } from '../../filter-operator-selector'
import { getMissingValuePresets } from '../../utils'

const TextForm = ({
  label,
  value,
  onChange,
  operator = 'contains',
  onPress,
}: FilterComponentProps) => {
  const { handleKeyDown } = useKeyPress('Enter', onPress)

  const textInput = (
    <TextField.Root
      value={value || ''}
      onChange={e => onChange(e.target.value, operator)}
      onKeyDown={handleKeyDown}
      type="text"
      placeholder={label}
      autoFocus
    />
  )

  const allFilterOperators: FilterOperatorOption[] = [
    { operator: 'contains', component: textInput },
    { operator: 'equals', component: textInput },
    { operator: 'not_equals', component: textInput },
  ]

  return (
    <FilterOperatorSelector
      operator={operator}
      value={value}
      operators={allFilterOperators}
      presets={getMissingValuePresets(label)}
      onChange={onChange}
      onKeyDown={handleKeyDown}
    />
  )
}

export default TextForm
